/** 
 * @type {NewsFilter} 
 */
const filter = {
    with: null,
    orderBy: null,
    ids: null,
    account_ids: null,
    categories: null,
    dateRange: null,
}
/** 
* @returns {NewsFilter} 
*/
export default function () {
    return JSON.parse(JSON.stringify(filter));
} 



// WEBPACK FOOTER //
// ./resources/js/filters/NewsFilter.js